var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    fill: "none",
    stroke: "currentColor",
    className: "app-store_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 8,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.185,
    y: 2.185,
    width: 7.63,
    height: 7.63,
    rx: 0.954,
    transform: "rotate(-45 18 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 8,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 8,
    height: 8,
    rx: 1
  }))));
}

export default SvgAppStore;